import {
  RoomAnyId,
  RoomContextId,
  RoomEntity,
  RoomId,
  RoomPid
} from "@common/domain";
import { createAction, props } from "@ngrx/store";
import { RoomStreamToSubscribeVO, RoomStreamVO } from "@youm-front/room/domain";

/**
 * @deprecated
 * This action enables too much logic - room, streams and producer.
 */
export const init = createAction("[Room] Init");
export const destroy = createAction("[Room] Destroy");

export const reset = createAction("[Room] Reset");

export const loadRoomData = createAction(
  "[Room] Load Room Data",
  props<{ roomId: RoomAnyId }>()
);
export const loadRoomDataFailure = createAction(
  "[Room] Load Room Data Failure",
  props<{ error: string }>()
);
export const loadRoomDataSuccess = createAction(
  "[Room] Load Room Data Success",
  props<{ room: RoomEntity }>()
);

export const joinRoom = createAction(
  "[Room] Join Room",
  // TODO: use RoomId for join,
  // RoomPid should only be used to load room data
  props<{ roomId: RoomPid; roomContextId: RoomContextId }>()
);
export const joinRoomFailure = createAction(
  "[Room] Join Room Failure",
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ error: any }>()
);
export const joinRoomSuccess = createAction("[Room] Join Room Success");

export const startLiveStream = createAction(
  "[Room] Start Live Stream",
  props<{ roomId: RoomId }>()
);
export const startLiveStreamFailure = createAction(
  "[Room] Start Live Stream Failure",
  props<{ code: number; message: string; untilNextLiveMs?: number }>()
);
export const startLiveStreamSuccess = createAction(
  "[Room] Start Live Stream Success",
  props<{ room: RoomEntity }>()
);

export const stopLiveStream = createAction(
  "[Room] Stop Live Stream",
  props<{ roomId: RoomId }>()
);
export const stopLiveStreamFailure = createAction(
  "[Room] Stop Live Stream Failure",
  props<{ error: string }>()
);
export const stopLiveStreamSuccess = createAction(
  "[Room] Stop Live Stream Success",
  props<{ roomId: RoomId }>()
);

export const listRoomStreams = createAction(
  "[Room] List Room Streams",
  props<{ roomId: RoomId }>()
);
export const listRoomStreamsFailure = createAction(
  "[Room] List Room Streams Failure",
  props<{ error: string }>()
);
export const listRoomStreamsSuccess = createAction(
  "[Room] List Room Streams Success",
  props<{ streams: RoomStreamToSubscribeVO[] }>()
);

export const toggleStreamSound = createAction(
  "[Room] Toggle Stream Sound",
  props<{ stream: RoomStreamVO }>()
);
export const toggleLocalVideoStream = createAction(
  "[Room] Toggle Local Video Stream"
);
export const toggleScreenStream = createAction("[Room] Toggle Screen Stream");
export const toggleLocalAudioStream = createAction(
  "[Room] Toggle Local Audio Stream"
);

export const publishLocalVideoStream = createAction(
  "[Room] Publish Local Video Stream",
  props<{ file: File }>()
);
export const publishLocalVideoStreamFailure = createAction(
  "[Room] Publish Local Video Stream Failure",
  props<{ error: string }>()
);
export const publishLocalVideoStreamSuccess = createAction(
  "[Room] Publish Local Video Stream Success",
  props<{ roomStreamVO: RoomStreamVO }>()
);

export const publishLocalAudioStream = createAction(
  "[Room] Publish Local Audio Stream",
  props<{ file: File }>()
);
export const publishLocalAudioStreamFailure = createAction(
  "[Room] Publish Local Audio Stream Failure",
  props<{ error: string }>()
);
export const publishLocalAudioStreamSuccess = createAction(
  "[Room] Publish Local Audio Stream Success",
  props<{ roomStreamVO: RoomStreamVO }>()
);

export const publishWebcamStream = createAction("[Room] Publish Webcam Stream");
export const publishWebcamStreamFailure = createAction(
  "[Room] Publish Webcam Stream Failure",
  props<{ error: string }>()
);
export const publishWebcamStreamSuccess = createAction(
  "[Room] Publish Webcam Stream Success",
  props<{ roomStreamVO: RoomStreamVO }>()
);

export const publishScreenStream = createAction("[Room] Publish Screen Stream");
export const publishScreenStreamFailure = createAction(
  "[Room] Publish Screen Stream Failure",
  props<{ error: string }>()
);
export const publishScreenStreamSuccess = createAction(
  "[Room] Publish Screen Stream Success",
  props<{ roomStreamVO: RoomStreamVO }>()
);

export const picLocalWebcamStream = createAction(
  "[Room] Pic Local Webcam Stream"
);
export const unpicLocalWebcamStream = createAction(
  "[Room] Unpic Local Webcam Stream"
);

export const muteLocalWebcamStream = createAction(
  "[Room] Mute Local Webcam Stream"
);
export const unmuteLocalWebcamStream = createAction(
  "[Room] Unmute Local Webcam Stream"
);

export const disposeRoomLocalData = createAction(
  "[Room] Dispose Room Local Data"
);
export const disposeRoomRemoteData = createAction(
  "[Room] Dispose Room Remote Data"
);
